import { atom } from "jotai";
export const userRole = atom("");
export const userTutorCityAccess = atom([]);
export const userStudentCityAccess = atom([]);
export const userShadowTutorCityAccess = atom([]);
export const userStudentCityAssignmentAccess = atom([]);
export const userTutorCityAssignmentAccess = atom([]);
export const adminEditDealState = atom(false);
export const isTransferPaymentAccess = atom(false);
